<div class='wrap'>

  <section id='roteiro-lista' *ngIf="mostrarMenu;else abrirMenu">
    <header>
      <h1>Roteiros ({{ totalRoteiros }}) </h1>

      <div class="d-flex align-items-center">
        <button id="bt-filtro" (click)="recarregaDados()" [class.open]="btFiltro" title="Recarregar dados">
          <i class="fa fa-refresh"></i>
        </button>
        <i  *ngIf="mainContainerService.listOcorrenciasRoteiroStatus.length > 0" class="fa fa-chevron-left  btn-hover mr-2 ml-2"  title="Minimizar" (click)="esconderMostrarMenu()"></i> 
      </div> 
    </header>
    <div id="filtro">
      <section *ngIf="popupConfigService.filtroAvancadoAtivo" class="filtro-avancado w-100 mb-3" >
      
        <div>
          <p>Atendente</p>
          <div class="d-flex justify-content-between form-control btn-hover" (click)="alteraShowUsuario()">
            <span class="linha-unica"> {{ popupConfigService.usuariosDescSelecionados }}</span>
            <div>
              <span *ngIf="popupConfigService.qtdUsuarioSel" class="info-qtd"> +{{ popupConfigService.qtdUsuarioSel }}</span>    
              <i class="fa" [ngClass]="{'fa-angle-down': !mostraUsuarios, 'fa-angle-up': mostraUsuarios}"></i>
            </div>
           
        </div>
        <div class="select-custom " *ngIf="mostraUsuarios">
          <div class="form-control ajuste-pad"  style="border: none;"    *ngFor="let usuario of popupConfigService.usuariosOcorrencia"  >    
            <span  (click)="atualizaUsuariosFiltrados(usuario)" > 
              <input class="mr-2" type="checkbox" [checked]="usuario.checked" >
              {{ usuario.Usuario }} </span>
          </div>
        </div> 
        </div>
   
        <div >
          <p>Motoristas</p> 
          <div class="d-flex justify-content-between form-control btn-hover" (click)="alteraShowMotorista()">
              <span class="linha-unica"> {{ popupConfigService.descMotoristas }}</span>
              <div>
                <span *ngIf="popupConfigService.qtdMotorSel" class="info-qtd"> +{{ popupConfigService.qtdMotorSel }}</span>  
                <i class="fa" [ngClass]="{'fa-angle-down': !mostraMotoristas, 'fa-angle-up': mostraMotoristas}"></i>
              </div>
             
          </div>
          <div class="select-custom " *ngIf="mostraMotoristas">
            <div class="form-control ajuste-pad" style="border: none;" *ngFor="let motorista of popupConfigService.motoristasFiltro"   >    
              <span > 
                <input class="mr-2" type="checkbox"[checked]="motorista.checked" disabled>
                {{ motorista.Nome }} </span>
            </div>
          </div>        
        </div>
    
      </section>

      
    
   
      <p class="txt-white-color">Filtrar por:</p>     
     
      <div class="conteudo">
        <div class=" mb-3 filtro-opcao" *ngFor="let filtro of filtroPorTipo" >
          <div class="d-flex btn-hover" (click)="tipoFiltro(filtro.tipo)">
            <img src="assets/imgs/radio_checked.svg" *ngIf="filtro.tipo == filtroPor;else noChecked" class="mr-1 ">  {{ filtro.descricao }} 
            <ng-template #noChecked>
              <img src="assets/imgs/radio_no_checked.svg" class="mr-1" >
            </ng-template>
            
          </div>
          
        </div>
      </div>
      <div class="conteudo search">
        <div class="filtro-input">
          <input type="search" placeholder="Buscar" results="5" name="s" [(ngModel)]="busca"
            (keypress)="filtroRoteiro($event, false)" (focusout)="null" (focus)='resetfeedback()'>
          <img src="assets/imgs/icon_clear_bt.png" class="bt-clear" (click)="limparFiltro()" [hidden]="!carregandoInfo">
        </div>
        <button hidden="true" id="btnAtualizaListaOcorrencias" (click)="atualizaListaOcorrencias()"> </button>
        <button class="bt-search" (keyup.enter)="filtroRoteiro($event)" (click)="filtroRoteiro($event)" [disabled]="loadingBtnBusca"
          [disabled]='busca === ""'>
          <img src="assets/imgs/icon_lupa.svg">
        </button>
      </div>
      <span id='search-alerta' *ngIf="mainContainerService?.listaRoteiros?.length == 0 && search == true"> <i
          class='fa fa-thumbs-down'></i> Nenhum resultado encontrado! </span>
    </div>

    <div class="scroll ajuste-scroll">
      <div id='loading' [hidden]="carregandoInfo">
        <img src="assets/imgs/loading2.gif" alt="loading">
        Carregando
      </div>
      <ul id="roteiro-item">
        <ng-container *ngFor="let item of mainContainerService.listaRoteiros, let i = index">
          <li  *ngIf="item.mostraRoteiro">
            <button  class="item"
              [class.selected]="item.roteiro == mainContainerService.roteiroSelecionado"
              (click)="visualizarOcorrenciasDoRoteiro(item.roteiro)">
              <header>
                <img class="olho" src="assets/imgs/icon-eye.svg">
                <div class="titulo">
                  <h3>{{ item?.roteiro }} </h3>
                  <h6 class="data-saida">{{ util.converteData(item?.PrevisaoSaida) | date: 'dd/MM/yyyy HH:mm' }}</h6>
                </div>
                <div class="status">
                  <div class="icon em-aberto" [class.zero]="item?.qtdOcorrenciasPorStatus?.novo?.length == 0"
                    title="Ocorrências em Aberto">
                    <img src=" assets/imgs/exclamation-circle.svg" alt="">
                    <span class="valor ml-1">{{ item?.qtdOcorrenciasPorStatus?.novo?.length }}</span>
                  </div>
                  <div class="icon em-analise" [class.zero]="item?.qtdOcorrenciasPorStatus?.analise?.length == 0"
                    title="Ocorrências em Análise">
                    <img src="assets/imgs/clock-history.svg" alt="">
                    <span class="valor ml-1">{{ item?.qtdOcorrenciasPorStatus?.analise?.length }}</span>
                  </div>
                  <div class="icon finalizadas" [class.zero]="item?.qtdOcorrenciasPorStatus?.finalizado?.length == 0"
                    title="Ocorrências Finalizadas">
                    <img src="assets/imgs/check-circle.svg" alt="">
                    <span class="valor ml-1">{{ item?.qtdOcorrenciasPorStatus?.finalizado?.length
                      }}</span>
                  </div>
                </div>
              </header>
              <section>
                <div>
                  <h4>{{ item.cod_veiculo }} - {{ item.veiculo }} | {{ item.nome_motorista }}</h4>
                </div>
              </section>
            </button>
          </li>
          <ng-template #semOcorrencia>
            <button class="item "
            [hidden]="!filtro"
            [class.selected]="item.roteiro == mainContainerService.roteiroSelecionado"
              (click)="visualizarOcorrenciasDoRoteiro(item.roteiro)">
              <header>
                <img class="olho" src="assets/imgs/icon-eye.svg">
                <div class="titulo">
                  <h3>{{ item?.roteiro }} </h3>
                  <h6 class="data-saida">{{ util.converteData(item?.PrevisaoSaida) | date: 'dd/MM/yyyy HH:mm' }}</h6>
                </div>
                <div class="status">
                  <div class="icon em-aberto" [class.zero]="item?.qtdOcorrenciasPorStatus?.novo?.length == 0"
                    title="Ocorrências em Aberto">
                    <img src="assets/imgs/exclamation-circle.svg" alt="">
                    <span class="valor ml-1" >{{ item?.qtdOcorrenciasPorStatus?.novo?.length }}</span>
                  </div>
                  <div class="icon em-analise" [class.zero]="item?.qtdOcorrenciasPorStatus?.analise?.length == 0"
                    title="Ocorrências em ">
                    <img src="assets/imgs/clock-history.svg" alt="">
                    <span class="valor ml-1">{{ item?.qtdOcorrenciasPorStatus?.analise?.length }}</span>
                  </div>
                  <div class="icon finalizadas" [class.zero]="item?.qtdOcorrenciasPorStatus?.finalizado?.length == 0"
                    title="Ocorrências Finalizadas">
                    <img src="assets/imgs/check-circle.svg" alt="">
                    <span class="valor ml-1">{{ item?.qtdOcorrenciasPorStatus?.finalizado?.length
                      }}</span>
                  </div>
                </div>
              </header>
              <section>
                <div>
                  <h4>{{ item.cod_veiculo }} - {{ item.veiculo }} | {{ item.nome_motorista }}</h4>
                </div>
              </section>
            </button>
          </ng-template>
        </ng-container>
      </ul>
    </div>
  </section>
  <section id='roteiro-selecionado'>
    <article id='lista-ocorrencias'>
      <div  class="loading" *ngIf="mainContainerService.loadingProcessando" >
        <img src='assets/imgs/loading2.gif'> Processando... 
     </div>    
      <info-list-ocurrence></info-list-ocurrence>
    </article>
  </section>

  <ng-template #abrirMenu>
    <span  (click)="esconderMostrarMenu()" class="menu-mostrar btn-hover"><i class="fa fa-chevron-right" ></i></span>
  </ng-template>
  
</div>
